import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { WorkMaterialCategory } from './work-material-category.interface';

export class WorkMaterialCategoryService {
   async getWorkMaterialCategories(employerId: number, query?: LocationQuery): Promise<ApiResource<Array<WorkMaterialCategory>>> {
      const response = await http.get<ApiResource<Array<WorkMaterialCategory>>>(`/employers/${employerId}/work-material-categories`, {
         params: { ...query },
      });

      return response.data;
   }

   async getWorkMaterialCategory(
      employerId: number,
      WorkMaterialCategoryId: number,
      query?: LocationQuery,
   ): Promise<ApiResource<WorkMaterialCategory>> {
      const response = await http.get<ApiResource<WorkMaterialCategory>>(
         `/employers/${employerId}/work-material-categories/${WorkMaterialCategoryId}`,
         { params: { ...query } },
      );
      return response.data;
   }

   async postWorkMaterialCategory(
      employerId: number,
      WorkMaterialCategory: WorkMaterialCategory,
   ): Promise<ApiResource<WorkMaterialCategory>> {
      const response = await http.post<ApiResource<WorkMaterialCategory>>(
         `/employers/${employerId}/work-material-categories`,
         WorkMaterialCategory,
      );
      return response.data;
   }

   async putWorkMaterialCategory(
      employerId: number,
      WorkMaterialCategoryId: number,
      WorkMaterialCategory: WorkMaterialCategory,
   ): Promise<ApiResource<WorkMaterialCategory>> {
      const response = await http.put<ApiResource<WorkMaterialCategory>>(
         `/employers/${employerId}/work-material-categories/${WorkMaterialCategoryId}`,
         WorkMaterialCategory,
      );
      return response.data;
   }

   async deleteWorkMaterialCategory(employerId: number, WorkMaterialCategoryId: number): Promise<void> {
      const response = await http.delete(`/employers/${employerId}/work-material-categories/${WorkMaterialCategoryId}`);
      return response.data;
   }
}
